import { createAction } from '../../utils/redux/createAction';

import * as changeRoom from './requests/change-room-req';

const actionsScope = 'dashboard/change-room-modal';

export const DASHBOARD_CHANGE_ROOM = {
  OPEN: `${actionsScope}/open`,
  CLOSE: `${actionsScope}/close`,
};

export const dashboardChangeRoomActions = {
  open: createAction(DASHBOARD_CHANGE_ROOM.OPEN),
  close: createAction(DASHBOARD_CHANGE_ROOM.CLOSE),
};

const initialState = {
  opened: false,
  appointment: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case DASHBOARD_CHANGE_ROOM.OPEN: {
      return {
        ...state,
        opened: true,
        appointment: payload,
      };
    }

    case changeRoom.consts.SUCCEED:
    case DASHBOARD_CHANGE_ROOM.CLOSE: {
      return { ...initialState };
    }

    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/redux/dashboard/change-room-modal.js